import { render, staticRenderFns } from "./SignupTos.vue?vue&type=template&id=03b4909f"
import script from "./SignupTos.vue?vue&type=script&lang=js"
export * from "./SignupTos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports